import axios from "axios";
import config from "../Config.json";


const RegisterUser = async (data) => {
    try {
        data.is_active = true;
        const response = await axios.post(`${config.API_URL}/user/register`, data)
        return response
    } catch (error) {
        return error
    }
}

export default RegisterUser;